export const apiErrorMessage = error =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message;

export const addMemberErrorMessage = (error, t) => {
  const serverMessage = error?.response?.data?.message;
  if (
    error?.response?.status === 422 &&
    /already in this list/i.test(serverMessage || '')
  ) {
    return t('LISTS_PAGE.ALREADY_IN_LIST');
  }
  return apiErrorMessage(error);
};

export const skippedMemberMessage = (result, t) => {
  switch (result?.skipped) {
    case 'already_member':
      return t('LISTS_PAGE.ALREADY_IN_LIST');
    case 'blocked':
      return t('LISTS_PAGE.MEMBERS.BLOCKED_NOT_ADDED');
    default:
      return null;
  }
};
